import Rule from './Rule';
export default class RuleGroup extends Rule {
    members;
    constructor(alias, actionName, resourceToModify, members) {
        super({ alias, actionName, resourceToModify });
        this.members = members;
    }
    isAllowed(aliases) {
        return this.members.some((member) => member.isAllowed(aliases));
    }
}
//# sourceMappingURL=RuleGroup.js.map